// get-categories.selectors.ts
import { createSelector } from '@ngrx/store';
import { orderBy } from 'lodash';
import { Category, ProjectWithRelations } from '@rappider/rappider-sdk';

export const getCategories = createSelector(
  state => state['activeProject']?.data,
  state => state['category']?.data || [],
  (
    activeProject: ProjectWithRelations | null,
    categories: Category[]
  ) => {
    if (activeProject) {
      return orderBy(
        categories?.filter(category => category?.projectId === activeProject?.id),
        ['type', category => category.title.toLowerCase(), 'name'],
        ['asc', 'asc', 'asc']
      ) || []
    }
    return [];
  }
);
